import React from "react";
import { Grid, Panel, Row } from "rsuite";

export const CategoriesWrap = ({ children }) => (
  <Panel bordered>
    <Grid fluid>
      <Row className="nh-categories-row">{children}</Row>
    </Grid>
  </Panel>
);
